/**
 * Shared utility for consistent color and resource logic.
 */

// Premium iOS-style palette
// Premium iOS-style palette with labels
export const RESOURCE_PALETTE = [
    { hex: '#007aff', label: 'Blau' },
    { hex: '#5856d6', label: 'Indigo' },
    { hex: '#af52de', label: 'Lila' },
    { hex: '#ff2d55', label: 'Pink' },
    { hex: '#ff9500', label: 'Orange' },
    { hex: '#34c759', label: 'Grün' },
    { hex: '#5ac8fa', label: 'Teal' },
    { hex: '#ff6482', label: 'Rose' },
    { hex: '#30b0c7', label: 'Cyan' }
];

/**
 * Helper to find a color object by hex.
 */
export const findPaletteColor = (hex) => RESOURCE_PALETTE.find(c => c.hex === hex) || null;

/**
 * Returns a color for a worker. 
 * If worker.color is set, uses that.
 * Otherwise, calculates a deterministic hash from the name.
 * 
 * @param {Object} worker - Worker object with name and optional color
 * @returns {string} Hex color code
 */
export function getResourceColor(worker) {
    if (!worker) return '#cbd5e1';
    if (typeof worker === 'string') return getResourceColor({ name: worker });
    
    // 1. Precise match (Manual assignment)
    if (worker.color && worker.color.startsWith('#')) {
        return worker.color;
    }

    // 2. Fallback: Deterministic hashing (from Sidebar logic)
    const name = worker.name || 'Unbekannt';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return RESOURCE_PALETTE[Math.abs(hash) % RESOURCE_PALETTE.length].hex;
}

/**
 * Returns initials for a name (max 2 characters).
 */
export function getInitials(name) {
    if (!name) return '?';
    return name
        .split(' ')
        .filter(n => n.length > 0)
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}
